var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargerTimeToUnplug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15689_2164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 197,
    height: 197
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.39 196.78C152.729 196.78 196.78 152.729 196.78 98.39C196.78 44.0507 152.729 0 98.39 0C44.0507 0 0 44.0507 0 98.39C0 152.729 44.0507 196.78 98.39 196.78Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15689_2164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15689_2164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 195,
    height: 195
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4303 193.61C151.03 193.61 194.481 150.159 194.481 96.5593C194.481 42.9595 151.03 -0.491821 97.4303 -0.491821C43.8304 -0.491821 0.37915 42.9595 0.37915 96.5593C0.37915 150.159 43.8304 193.61 97.4303 193.61Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15689_2164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-189.997 1.21002V1.84717L-189.457 1.52454L-189.997 1.21002ZM-189.997 1.21002V1.84717L-189.457 1.52454L-189.997 1.21002ZM231.518 -157.913L210.007 -170.479L209.733 -170.64L39.0848 -270.328L22.0991 -260.408L-163.357 -152.065L-226.509 -115.174L-226.566 -115.142L-56.1032 -15.3241V95.0269L-78.8235 81.719L-104.963 97.1401L-189.997 47.3442L-222.888 28.084L-239.366 18.4377L-244.406 15.4858V-15.2354L-244.527 -15.308V15.389L-329.569 -34.4149V-54.9656L-409.998 -7.98456L39.0848 254.359L488.167 -7.98456L231.518 -157.913ZM-189.997 1.84717L-189.457 1.52454L-189.997 1.21002V1.84717ZM-189.997 1.21002V1.84717L-189.457 1.52454L-189.997 1.21002ZM-189.997 1.21002V1.84717L-189.457 1.52454L-189.997 1.21002Z",
    fill: "url(#paint0_radial_15689_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.167 -7.97632V18.1395L39.0848 280.483L-409.99 18.1395V-7.97632L39.0848 254.359L488.167 -7.97632Z",
    fill: "url(#paint1_linear_15689_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.051 -9.3394L389.124 -12.2107L291.928 -68.9912L287.338 -71.677L-57.7969 129.854L-53.4577 132.297L-53.4899 132.322L43.7064 189.102L48.7795 186.231L-47.7716 129.829L15.2274 93.0107L111.77 149.412L116.852 146.541L20.2199 90.0911L83.2189 53.2805L179.843 109.722L184.916 106.859L88.2114 50.3608L151.21 13.5422L247.915 70.0324L252.988 67.1691L156.203 10.6306L219.202 -26.1881L315.979 30.3505L321.06 27.4792L224.194 -29.1077L287.193 -65.9183L384.051 -9.3394Z",
    fill: "url(#paint2_linear_15689_2164)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8767 89.6067C55.8124 88.526 58.2078 88.6228 60.0226 89.8971C64.2972 92.8974 66.3055 97.9625 67.1605 100.963C67.5637 102.39 67.0395 103.915 65.8458 104.786L62.9664 106.899L53.8848 89.6067H53.8767Z",
    fill: "#004158"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.279 139.685L124.038 136.193C124.038 136.193 122.239 123.981 112.819 120.925L110.19 122.393L119.271 139.685H119.279Z",
    fill: "#004158"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.548 89.5583C146.548 89.5583 146.073 82.4285 144.234 81.5736C143.064 81.0251 142.048 80.8799 141.459 80.8477C141.145 80.8315 140.846 80.9928 140.701 81.2671L139.741 83.0173L146.548 89.5664V89.5583Z",
    fill: "#004158"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.562 134.475C123.844 135.386 123.989 136.007 124.03 136.152C124.03 136.176 124.03 136.193 124.03 136.193C125.619 141.58 130.289 142.83 135.515 143.468C140.741 144.113 152.912 141.467 162.486 133.837C167.946 129.482 169.357 123.683 169.075 118.457C168.825 123.054 167.083 127.837 162.397 131.571C152.686 139.314 140.346 141.983 135.039 141.338C129.901 140.709 125.304 139.507 123.554 134.475H123.562Z",
    fill: "url(#paint3_linear_15689_2164)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4723 72.9354C41.3594 74.0727 40.8029 79.7588 40.3915 80.1701C39.9318 80.6299 38.4961 79.7991 38.4961 79.7991C38.4961 79.7991 38.5365 83.3479 39.7866 86.3805C40.0366 87.0015 40.3431 87.5903 40.7061 88.1307C42.2143 90.3809 46.3922 93.8894 48.7312 95.7606C49.6587 96.5026 50.9895 96.43 51.8444 95.6073L51.8686 95.5831C51.5218 93.2442 52.1025 91.7117 52.6348 90.8407C52.6832 90.7681 52.7235 90.6874 52.7719 90.6229C52.7881 90.5987 52.8042 90.5745 52.8203 90.5584C53.1107 90.147 53.3526 89.9615 53.3526 89.9615L53.4898 89.8809L53.522 89.8567L53.9011 89.6389L54.3528 89.3728H54.3689L54.3931 89.3486L54.4173 89.3324L54.4979 89.284C54.5625 89.2598 54.6189 89.2437 54.6834 89.2195C54.6834 89.2195 54.6834 89.2195 54.6915 89.2195C56.1836 88.7517 57.7564 88.6711 59.1759 89.526C61.3858 90.8487 63.0715 92.849 64.3377 94.9137C65.8702 97.4059 66.7816 100.011 67.2574 101.664C67.2574 101.664 67.2574 101.681 67.2574 101.689C67.5639 102.737 67.693 103.399 67.693 103.399L67.8381 104.931L67.9188 105.77C67.9833 106.407 68.3382 106.988 68.8786 107.334L102.898 128.853L106.915 131.2C107.552 131.571 108.335 131.079 108.278 130.345L108.157 128.716V128.676L108.101 127.966C108.101 127.966 108.076 127.877 108.052 127.724C108.052 127.724 108.052 127.708 108.052 127.7C107.972 127.095 107.851 125.514 108.609 124.102C109.214 122.989 110.125 122.304 110.948 121.884C111.109 121.796 111.27 121.723 111.424 121.659C111.472 121.634 111.528 121.61 111.577 121.594C111.577 121.594 111.577 121.594 111.585 121.594C112.359 121.312 113.214 121.304 113.988 121.57C119.271 123.433 122.151 130.256 123.336 133.878C123.336 133.894 123.336 133.91 123.344 133.918C123.409 134.104 123.465 134.281 123.514 134.45C123.514 134.45 123.514 134.467 123.514 134.475C123.602 134.717 123.691 134.958 123.796 135.184C125.716 139.62 130.119 140.741 134.999 141.338C140.298 141.992 152.646 139.314 162.357 131.571C167.043 127.837 168.793 123.054 169.035 118.457C168.938 116.642 168.632 114.9 168.22 113.311L164.97 119.312C164.833 119.562 164.462 119.529 164.373 119.255L163.22 115.618C163.139 115.351 163.155 115.077 163.26 114.819L166.123 108.068C165.938 107.786 165.688 107.455 165.381 107.092C161.752 102.729 150.17 92.7118 146.508 89.5744C145.807 88.9695 145.395 88.6227 145.395 88.6227C145.395 88.6227 143.016 86.324 139.798 83.114C139.766 83.0817 139.741 83.0575 139.709 83.0253C136.499 79.8314 132.482 75.7583 129.143 72.1531C122.409 64.8862 113.569 57.4256 100.455 53.4494C85.0497 48.7795 71.1772 48.1262 71.1772 48.1262C71.1772 48.1262 71.1772 48.1262 71.1611 48.1262C64.7329 49.1747 53.4978 52.288 46.4648 58.5225C43.0612 61.539 41.0771 64.2813 39.9318 66.3137C39.2543 67.5155 38.8752 68.4591 38.6736 69.0721C38.5042 69.5641 38.4478 69.8383 38.4478 69.8383V71.0643L41.2706 72.6532C41.3836 72.7096 41.44 72.8306 41.4239 72.9435L41.4723 72.9354Z",
    fill: "url(#paint4_linear_15689_2164)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.068 110.529C97.1883 105.407 65.0234 84.5175 58.1839 80.0816C56.6273 79.0653 55.1836 77.8878 53.9092 76.5328C53.8851 76.5086 53.8609 76.4844 53.8447 76.4602C52.9414 75.4843 53.8044 73.9196 55.111 74.1616C59.176 74.9197 66.8784 77.0651 77.8151 83.1706C89.7197 89.8165 101.753 104.947 105.568 109.996C105.818 110.335 105.415 110.762 105.06 110.537L105.068 110.529Z",
    fill: "url(#paint5_linear_15689_2164)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.129 90.7196C142.766 92.8731 131.902 102.156 112.634 110.028C112.021 110.278 111.311 110.133 110.843 109.673L93.8331 90.8164C93.4944 90.4776 93.5992 89.9131 94.0348 89.7195C98.5756 87.7435 117.094 80.0007 126.143 71.2497C126.409 70.9916 126.845 71.0077 127.103 71.282L145.17 89.7679C145.42 90.0421 145.403 90.4696 145.129 90.7196Z",
    fill: "url(#paint6_linear_15689_2164)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7922 52.3605C90.1793 52.1992 90.1148 51.6346 89.7115 51.5539C87.921 51.199 84.0738 50.5296 76.6133 49.5295C73.3468 49.094 71.9837 49.6586 69.927 50.7313C64.2893 53.6509 54.8447 58.6676 49.1344 63.1036C47.9488 64.0231 48.0859 65.8458 49.3925 66.5798L56.6917 70.669C57.1192 70.9109 57.6434 70.8867 58.0547 70.6125C61.4584 68.2897 77.4117 57.603 89.8002 52.3685L89.7922 52.3605Z",
    fill: "url(#paint7_linear_15689_2164)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M109.875 133.587C112.383 138.362 116.594 141.088 119.279 139.677C121.965 138.265 122.102 133.257 119.594 128.474C117.086 123.699 112.609 120.546 110.19 122.384C107.464 124.449 107.367 128.805 109.875 133.587Z",
    fill: "#004158"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.105 137.435C120.049 136.414 120.054 132.597 118.117 128.91C116.179 125.223 113.033 123.062 111.089 124.084C109.145 125.105 109.14 128.922 111.077 132.609C113.014 136.296 116.161 138.457 118.105 137.435Z",
    fill: "#007FBC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5544 100.801C56.0628 105.576 60.2729 108.302 62.9587 106.891C65.6445 105.479 65.7816 100.471 63.2733 95.688C60.7649 90.9133 56.466 88.0258 53.869 89.5986C51.1106 91.2681 51.0461 96.0187 53.5544 100.801Z",
    fill: "#004158"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4963 71.0562V79.7991C38.4963 79.7991 39.932 80.6217 40.3917 80.1701C40.803 79.7587 41.3596 74.0807 41.4725 72.9354C41.4805 72.8144 41.4241 72.7015 41.3192 72.637L38.4963 71.0481V71.0562Z",
    fill: "#007FBC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.806 131.757C144.25 131.7 144.468 131.176 144.185 130.829C143.355 129.813 141.806 128.184 140.298 128.055C138.54 127.909 132.966 127.998 130.66 128.038C130.192 128.046 129.902 128.547 130.127 128.958C130.829 130.24 132.168 132.45 133.144 132.644C134.257 132.87 141.201 132.071 143.806 131.757Z",
    fill: "#80DAEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 115.61L164.422 119.247C164.51 119.521 164.881 119.562 165.018 119.304L168.277 113.303C167.696 111.045 166.906 109.182 166.172 108.052L163.309 114.811C163.204 115.061 163.188 115.344 163.268 115.61Z",
    fill: "#80DAEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7803 104.655C63.7243 103.633 63.7298 99.8164 61.7925 96.1295C59.8552 92.4426 56.7088 90.2819 54.7648 91.3034C52.8208 92.3249 52.8154 96.1418 54.7527 99.8286C56.6899 103.516 59.8363 105.676 61.7803 104.655Z",
    fill: "#007FBC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0991 109.988C93.2684 110.52 93.7282 110.907 94.2766 111.004C96.3333 111.375 102.632 111.311 104.197 111.311C104.326 111.311 104.423 111.287 104.495 111.246C104.536 111.222 104.576 111.198 104.6 111.158L105.584 110.44C105.705 110.335 105.729 110.157 105.625 110.028L102.616 106.133L102.447 105.915L102.431 105.899C101.987 105.399 101.31 105.133 100.6 105.246C98.2287 105.633 94.7121 106.673 93.4459 107.205C92.5345 107.585 92.7845 109.02 93.0991 109.988Z",
    fill: "#004158"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1919 89.5342C61.4018 90.8569 63.0875 92.8571 64.3538 94.9219C65.8862 97.4141 66.7976 100.019 67.2734 101.673C67.5799 102.737 67.709 103.399 67.709 103.399L67.8542 104.931L67.9348 105.77C67.9993 106.407 68.3542 106.988 68.8946 107.335L102.915 128.853L106.931 131.2C107.568 131.571 108.351 131.079 108.294 130.345L108.165 128.676L108.109 127.958C108.109 127.958 108.084 127.869 108.06 127.716C107.98 127.127 107.842 125.522 108.617 124.094C109.222 122.981 110.133 122.296 110.956 121.876C107.633 123.102 107.084 127.167 107.004 128.829C106.988 129.143 106.641 129.321 106.375 129.16L70.7335 106.714C70.1689 106.359 69.7495 105.81 69.556 105.173C69.2575 104.205 68.8704 102.253 67.5396 98.7046C66.5153 95.9542 65.1119 94.1718 63.9021 92.8975C61.7164 90.5988 59.3209 89.5987 59.1838 89.5342H59.1919Z",
    fill: "url(#paint8_linear_15689_2164)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.479 28.4709L42.0771 22.4219L60.4985 32.9311L48.9004 38.9721L30.4871 28.4709H30.479Z",
    fill: "url(#paint9_linear_15689_2164)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9006 38.9722L50.8202 42.1177L62.3941 36.0767L60.4987 32.9312L48.9006 38.9722Z",
    fill: "url(#paint10_linear_15689_2164)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5676 30.0034L50.8039 42.1176L48.9004 38.9721L30.479 28.4709L29.5676 30.0034Z",
    fill: "url(#paint11_linear_15689_2164)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8428 -47.344L50.3039 -39.6657V35.2701L36.8428 27.5918V-47.344Z",
    fill: "url(#paint12_linear_15689_2164)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.304 35.2702L52.7397 34.0442V-40.819L50.304 -39.593V35.2702Z",
    fill: "url(#paint13_linear_15689_2164)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 -0.580613L45.3919 1.48413V-4.30684L41.7705 -6.37158V-0.580613Z",
    fill: "#004158"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9731 72.6695L49.457 75.4359L45.4807 73.8954L47.0373 71.1854L49.9731 72.6695Z",
    fill: "#007FBC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5857 78.4927C44.5857 78.4927 45.2229 74.1535 45.61 73.4115C45.9971 72.6614 47.5538 71.6451 47.5538 71.6451L49.1991 72.5081L48.3119 73.2985C48.3119 73.2985 47.1586 73.8551 47.1344 74.2987C47.1344 74.3874 47.094 74.5568 47.0376 74.7745C46.7956 75.6859 46.2068 77.4361 46.2068 77.4361L45.7794 78.1701L44.5857 78.4927Z",
    fill: "#002F3B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0374 74.7665L48.8601 74.4116L49.1989 72.5001L48.3117 73.2905C48.3117 73.2905 47.1583 73.847 47.1341 74.2906C47.1341 74.3794 47.0938 74.5487 47.0374 74.7665Z",
    fill: "#7A54C5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15689_2164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1168 91.6393C35.9717 95.2929 38.601 97.8013 40.8996 98.8417C41.811 99.2531 42.6982 99.4628 43.4886 99.4708C44.3597 99.4789 45.1098 99.2531 45.6018 98.7772C49.0457 95.4865 46.7309 88.268 45.6179 84.7998C45.384 84.082 45.2066 83.5174 45.134 83.1706C44.7146 81.2188 45.6824 77.9604 45.6905 77.9281L44.7468 78.3636C44.7146 78.4765 43.9 81.1785 44.3597 83.3319C44.4403 83.711 44.6259 84.2998 44.8597 85.0337C45.9244 88.3486 48.1343 95.2445 45.0533 98.1965C44.3597 98.8659 42.8111 98.8337 41.2222 98.1158C39.1414 97.1802 36.7621 94.9219 36.8992 91.6635C37.0121 88.9051 37.867 85.2434 38.7058 82.235C38.6252 81.7108 38.5445 80.9123 38.5042 80.1219C37.5202 83.3803 36.254 88.155 36.1168 91.6312V91.6393Z",
    fill: "#E3FCFF",
    fillOpacity: 0.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_15689_2164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4075 40.2383C43.4725 42.8676 47.6826 45.5938 49.6183 49.5539C50.5861 51.5218 50.9652 53.4656 50.7958 55.361C51.0701 55.1997 51.3604 55.0222 51.6105 54.869C51.683 53.143 51.3362 51.2476 50.3281 49.199C48.2875 45.0372 43.9886 42.2627 39.8349 39.577C34.2537 35.9636 29.4306 32.8423 31.334 27.2611C33.2939 21.4943 35.6813 20.599 37.7863 19.8167C40.1253 18.9456 42.1497 18.1875 42.3433 11.3077C42.4885 6.04095 41.69 1.30656 41.0609 -2.50032C40.1576 -7.88802 39.5607 -11.4529 42.0933 -12.4692L43.7225 -13.2354V-14.0984L41.7706 -13.187C38.6735 -11.9369 39.343 -7.92028 40.2705 -2.36321C40.9076 1.40334 41.69 6.10548 41.5448 11.2996C41.3754 17.6552 39.7462 18.2601 37.504 19.0908C35.3506 19.8973 32.6729 20.8975 30.5839 27.0191C28.4788 33.1891 33.7859 36.6169 39.4075 40.2464V40.2383Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15689_2164",
    x: 19.9803,
    y: 61.7973,
    width: 43.5671,
    height: 53.8046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.06542
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.890196 0 0 0 0 0.988235 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15689_2164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15689_2164",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_15689_2164",
    x: 13.982,
    y: -30.2292,
    width: 53.7685,
    height: 101.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.06542
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.890196 0 0 0 0 0.988235 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15689_2164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15689_2164",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15689_2164",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0848 -7.98455) scale(367.767 367.767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00A4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3BB7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#73CAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#A2DAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C7E6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E1EFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F1F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15689_2164",
    x1: -409.99,
    y1: 136.249,
    x2: 488.167,
    y2: 136.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B43B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#002F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#004056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00567C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#00689A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0075AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#007DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0080C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B43B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15689_2164",
    x1: -57.7969,
    y1: 58.7085,
    x2: 457.132,
    y2: 58.7085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00577C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00699A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0075AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#007DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#0080C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831731,
    stopColor: "#3DD2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A2E9F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15689_2164",
    x1: 169.115,
    y1: 131.006,
    x2: 123.562,
    y2: 131.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15689_2164",
    x1: 169.083,
    y1: 94.7766,
    x2: 38.4881,
    y2: 94.7766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#004158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00577C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00699A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0075AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#007DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0080C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#004158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15689_2164",
    x1: 105.649,
    y1: 92.3652,
    x2: 53.4737,
    y2: 92.3652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00E7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15689_2164",
    x1: 145.347,
    y1: 90.6067,
    x2: 93.6315,
    y2: 90.6067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00E7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15689_2164",
    x1: 90.0503,
    y1: 60.1033,
    x2: 48.3198,
    y2: 60.1033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00E7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15689_2164",
    x1: 108.343,
    y1: 95.1638,
    x2: 54.1349,
    y2: 128.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B1E5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#73D7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#41CBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1DC3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#07BDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#00BCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15689_2164",
    x1: 60.4985,
    y1: 30.697,
    x2: 30.479,
    y2: 30.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15689_2164",
    x1: 62.3941,
    y1: 37.5284,
    x2: 48.9006,
    y2: 37.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15689_2164",
    x1: 50.8039,
    y1: 35.2943,
    x2: 29.5676,
    y2: 35.2943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15689_2164",
    x1: 43.5693,
    y1: -47.344,
    x2: 43.5693,
    y2: 35.2701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9B9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15689_2164",
    x1: 51.5218,
    y1: -40.819,
    x2: 51.5218,
    y2: 35.2702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E5E5E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerTimeToUnplug);
export default __webpack_public_path__ + "static/media/charger-time-to-unplug.1f8c56c5162a5c545549d08db43fc9a8.svg";
export { ForwardRef as ReactComponent };